import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { handleOtpVerify, OneTimePassword } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { ENVIRONMENT_URL } from '@backrs_ui/grow-ui/src/settings';
import { handleAfterLogin } from '@backrs_ui/grow-ui/src/utils/loginHelper';
import { getGuestTokenIfPresent } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

import { usePostHog } from 'posthog-js/react';

export const OneTimePasswordContainer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const postHog = usePostHog();

  const handleOtpSubmission = async (code: string) => {
    try {
      const phone = location.state?.phone;
      const response = await handleOtpVerify(
        code,
        phone,
        ENVIRONMENT_URL,
        getGuestTokenIfPresent() ?? undefined,
      );

      if (!response.ok) {
        throw new Error('Error verifying OTP');
      }

      const otpResponse = await response.json();

      return await handleAfterLogin({
        access_token: otpResponse.token,
        dispatch,
        navigate,
        setErrorMessage,
        postHog,
      });
    } catch (error) {
      console.error(error);
      setErrorMessage('An error occurred. Please try again.');
    }
  };

  const handleBackToLoginNav = () => {
    navigate(APP_ROUTE.LOGIN);
  };

  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  return (
    <OneTimePassword
      handleOtpCode={handleOtpSubmission}
      errorMessage={errorMessage}
      environmentUrl={ENVIRONMENT_URL}
      phone={location.state?.phone}
      handleBackToLoginNav={handleBackToLoginNav}
    />
  );
};
